import { accountsActions, accountsSelectors, accountsTypes } from 'app-components/flux/accounts';
import { categoriesActions, categoriesSelectors, categoriesTypes } from 'app-components/flux/categories';
import {
  institutionLoginsActions,
  institutionLoginsSelectors,
  institutionLoginsTypes,
} from 'app-components/flux/institution-logins';
import store from 'app-components/utils/redux-store';

import { mergeMintImportSharedState } from './mintImportSharedState';

const importReset = async () => {
  const key = 'RESET';

  try {
    mergeMintImportSharedState({ key, progress: 10 });

    const accounts = accountsSelectors.getResourcesById(store.getState());
    if (accounts.size) {
      await new Promise((resolve, reject) => {
        store.dispatch(
          accountsActions.batchAccounts(
            accounts.map((account) =>
              accountsTypes.mkAccount(account.type, {
                clientId: account.clientId,
                id: account.id,
                isDeleted: true,
              }),
            ),
            { resolve, reject },
          ),
        );
      });
    }

    mergeMintImportSharedState({ key, progress: 30 });

    const institutionLogins = institutionLoginsSelectors.getInstitutionLoginsById(store.getState());
    if (institutionLogins.size) {
      await new Promise((resolve, reject) => {
        store.dispatch(
          institutionLoginsActions.batchInstitutionLogins(
            institutionLogins.map((institutionLogin) =>
              institutionLoginsTypes.mkInstitutionLogin({
                clientId: institutionLogin.clientId,
                id: institutionLogin.id,
                isDeleted: true,
              }),
            ),
            { resolve, reject },
          ),
        );
      });
    }

    mergeMintImportSharedState({ key, progress: 60 });

    const categories = categoriesSelectors.getResourcesById(store.getState());
    const mintExpenseRoot = categories.find(
      (category) => category.name === 'Mint Expense' && category.parentId === '0',
    );
    const mintIncomeRoot = categories.find((category) => category.name === 'Mint Income' && category.parentId === '0');
    const categpriesToDelete = [
      ...(mintExpenseRoot ? [mintExpenseRoot] : []),
      ...(mintIncomeRoot ? [mintIncomeRoot] : []),
    ];
    if (categpriesToDelete.length) {
      await new Promise((resolve, reject) => {
        store.dispatch(
          categoriesActions.batchCategories(
            categpriesToDelete.map((category) =>
              categoriesTypes.mkCategory({
                clientId: category.clientId,
                id: category.id,
                isDeleted: true,
              }),
            ),
            { resolve, reject },
          ),
        );
      });
    }

    mergeMintImportSharedState({ key, progress: 100 });
  } catch (e) {
    assert(false, e);
    mergeMintImportSharedState({ error: key });
  }
};

export default importReset;
